import { useEffect, useRef, useState } from "react";

import Grid from "@mui/material/Grid";

import Controls from "./Controls";
import Video from "./Video";
import ChatShell from "./chat/shell/Chat-Shell";
import useSound from "use-sound";
import boopSfx from "./sounds/sonido.mp3";

import firebase from "firebase/app";
import "firebase/firestore";
import axios from "axios";
import { API_START_RECORD, httpClient } from "./config/api";

const VideoCall = (props) => {
  const { setInCall, useClient, useTracks, token, uid, appID, channelName, consultaId, tipo, setPaginaError, extension, userName } = props;
  const [users, setUsers] = useState([]);
  const [start, setStart] = useState(false);
  const [message, setMessage] = useState(false);
  const [virtualBackgroundEnabled, setVirtualBackgroundEnabled] = useState(false);
  const client = useClient();
  const { ready, tracks } = useTracks();
  const [generales, setGenerales] = useState(null);
  const [iniciado, setIniciado] = useState(false);

  const [play] = useSound(boopSfx);

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  const [processor, setProcessor] = useState(null);

  // Set a solid color as the background
  async function setBackgroundColor() {
    if (tracks[1]) {
      // let processor = await getProcessorInstance();

      try {
        processor.setOptions({ type: "color", color: "#00ff00" });
        await processor.enable();
      } catch (e) {
        console.log(e);
      }

      setVirtualBackgroundEnabled(true);
    }
  }

  // Blur the user's actual background
  async function setBackgroundBlurring() {
    if (tracks[1]) {
      // let processor = await getProcessorInstance();

      try {
        processor.setOptions({ type: "blur", blurDegree: 2 });
        await processor.enable();
      } catch (e) {
        console.log(e);
      }

      setVirtualBackgroundEnabled(true);
    }
  }

  // Set an image as the background
  async function setBackgroundImage(url) {
    const imgElement = document.createElement("img");

    // descargar imagen con axios desde url
    const imagen = await axios.get(url, { responseType: "blob" });
    var urlCreator = window.URL || window.webkitURL;
    var imageUrl = urlCreator.createObjectURL(imagen.data);

    imgElement.onload = async () => {
      console.log("imgElement", imgElement);

      // await new Promise((resolve) => setTimeout(resolve, 5000));
      try {
        processor.setOptions({ type: "img", source: imgElement });
        await processor.enable();
      } catch (e) {
        console.log(e);
      }

      setVirtualBackgroundEnabled(true);
    };

    imgElement.src = imageUrl;
  }

  async function desactivarFondo() {
    // let processor = await getProcessorInstance();
    console.log(processor);

    try {
      await processor.disable();
    } catch (e) {
      console.log(e);
    }
    setVirtualBackgroundEnabled(false);
  }
  const db = firebase.firestore();

  // insertar teimpo en segundos
  const insertarTiempo = (segundos) => {
    db.collection("videollamadas").doc(consultaId).collection("otros").doc("generales").set(
      {
        segundos,
        medico: userName,
      },
      { merge: true }
    );
  };

  const insertarNombrePaciente = () => {
    db.collection("videollamadas").doc(consultaId).collection("otros").doc("generales").set(
      {
        paciente: userName,
      },
      { merge: true }
    );
  };

  useEffect(() => {
    // escuchar teimpo en segundos en realtime
    db.collection("videollamadas")
      .doc(consultaId)
      .collection("otros")
      .doc("generales")
      .onSnapshot((snaptshot) => {
        setGenerales(snaptshot.data());
        setIniciado(true);
      });

    if (tipo === "PACIENTE") {
      insertarNombrePaciente();
    }
  }, []);

  useEffect(() => {
    console.log("iniciado", iniciado);
    let unsuscribeInterval = null;
    if (iniciado && tipo === "MEDICO") {
      let segundos = 0;
      segundos = generales ? generales.segundos : segundos;
      unsuscribeInterval = setInterval(() => {
        segundos++;
        insertarTiempo(segundos);
      }, 1000);
    }
    return () => {
      clearInterval(unsuscribeInterval);
    };
  }, [iniciado]);

  useEffect(() => {
    let init = async (name) => {
      //* Publicar la pista de audio y video
      client.on("user-published", async (user, mediaType) => {
        await client.subscribe(user, mediaType);
        if (mediaType === "video") {
          setUsers([user]);
          console.log("nuevo usuario");
          play();
        }
        if (mediaType === "audio") {
          user.audioTrack.play();
        }
      });
      //* Cancelar la publicación de la pista de audio y video
      client.on("user-unpublished", (user, mediaType) => {
        if (mediaType === "audio") {
          if (user.audioTrack) user.audioTrack.stop();
        }
        if (mediaType === "video") {
          setUsers((users) => users.filter((u) => u.uid !== user.uid));
        }
      });
      //* Usuario desconectado
      client.on("user-left", (user) => {
        setUsers((users) => users.filter((u) => u.uid !== user.uid));
      });
      //* Usuario conectado
      try {
        const aaa = appID;
        await client.join(aaa, name, token, uid);
        if (tipo === "MEDICO") {
          setTimeout(function () {
            httpClient
              .post(API_START_RECORD, {
                uid: "99999",
                channelName,
              })
              .then((res) => {
                console.log("Grabacion iniciada");
                console.log(res);
              });
          }, 2000);
        }
      } catch (error) {
        console.error("Error al tratar de entrar a la sala: ", error);
        setPaginaError(true);
      }
      if (tracks) await client.publish([tracks[0], tracks[1]]);
      setStart(true);
    };
    if (ready && tracks) {
      try {
        init(channelName);
      } catch (error) {
        console.error("aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa", error);
      }
    }
  }, [client, ready, tracks, token, uid]);

  const startProces = async () => {
    if (!processor && tracks) {
      // Create a VirtualBackgroundProcessor instance
      const processorNew = extension.createProcessor();
      try {
        // Initialize the extension and pass in the URL of the Wasm file
        await processorNew.init("./assets/wasms");
      } catch (e) {
        console.log("Fail to load WASM resource!");
        return null;
      }
      // Inject the extension into the video processing pipeline in the SDK
      tracks[1].pipe(processorNew).pipe(tracks[1].processorDestination);
      setProcessor(processorNew);
    }
  };

  useEffect(() => {
    startProces();
  }, [tracks]);

  const getHoursMinutosYSegundos = (segundos) => {
    let horas = Math.floor(segundos / 3600);
    let minutos = Math.floor((segundos - horas * 3600) / 60);
    let segundosF = segundos - horas * 3600 - minutos * 60;

    return `${horas.toString().padStart(2, "0")}:${minutos.toString().padStart(2, "0")}:${segundosF.toString().padStart(2, "0")}`;
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
      }}
    >
      <Grid container className={message ? "movil" : ""} direction="column" style={{ height: "100%" }}>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {start && tracks && <Video tracks={tracks} users={users} message={message} userName={userName} tipoUsuario={tipo} generales={generales} />}
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {ready && tracks && (
            <Controls
              useClient={useClient}
              tracks={tracks}
              setStart={setStart}
              setInCall={setInCall}
              message={message}
              setMessage={setMessage}
              funcionFondo={setBackgroundImage}
              desactivarFondo={desactivarFondo}
              virtualBackgroundEnabled={virtualBackgroundEnabled}
            />
          )}
        </div>
        <div>
          {generales?.segundos && (
            <h2
              className="horaTranscurrida"
              style={{
                color: "white",
                marginLeft: 50,
                marginTop: 50,
                letterSpacing: 1,
                width: 120,
                textAlign: "center",
                backgroundColor: "black",
                borderRadius: 10,
              }}
            >
              {getHoursMinutosYSegundos(generales.segundos)}
            </h2>
          )}
        </div>
      </Grid>
      {message && (
        <div className="chat-panel" style={{ height: getWindowDimensions().height }}>
          <ChatShell tipo={tipo} consultaId={consultaId} userName={userName} uid={uid} />
        </div>
      )}
    </div>
  );
};

export default VideoCall;
